module.exports = __webpack_public_path__ + "static/logo-6d5d7d88ce03b3893f6b68c854c0bfe2.png";